"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientStatusBarLoadingPanel = exports.ClientBuiltinStatusBarLoadingPanel = void 0;
var tslib_1 = require("tslib");
var panel_1 = require("../../base/loading-panel/panel");
var ClientBuiltinStatusBarLoadingPanel = (function () {
    function ClientBuiltinStatusBarLoadingPanel() {
        this.visible = false;
    }
    ClientBuiltinStatusBarLoadingPanel.prototype.dispose = function () { };
    ClientBuiltinStatusBarLoadingPanel.prototype.show = function () { };
    ClientBuiltinStatusBarLoadingPanel.prototype.hide = function () { };
    return ClientBuiltinStatusBarLoadingPanel;
}());
exports.ClientBuiltinStatusBarLoadingPanel = ClientBuiltinStatusBarLoadingPanel;
var ClientStatusBarLoadingPanel = (function (_super) {
    tslib_1.__extends(ClientStatusBarLoadingPanel, _super);
    function ClientStatusBarLoadingPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loadingPanel = new ClientBuiltinStatusBarLoadingPanel();
        return _this;
    }
    return ClientStatusBarLoadingPanel;
}(panel_1.LoadingPanelBase));
exports.ClientStatusBarLoadingPanel = ClientStatusBarLoadingPanel;
